import {Snackbar, Alert, Backdrop, Button, CircularProgress,AlertColor } from "@mui/material";
import {useEffect, useState} from "react";

export interface ToastProps {
    isOpen: any,
    onClose: any,
    message: string | string[],
    severity: AlertColor
}

export function Toast(props:ToastProps){
    const {
        isOpen,
        onClose,
        message,
        severity
    } = props;

    const[toastMessage, setToastMessage]=useState("");
    useEffect(()=>{
        var isArray = Array.isArray(message);
        var toast = isArray ? (message as string[]).join("\r\n") : message as string;

        setToastMessage(toast);
    });

    return (
        <>
         <Snackbar
                open={isOpen} 
                autoHideDuration={6000} 
            onClose={onClose}
            anchorOrigin={ { vertical:"top", horizontal:"right" }}>
                <Alert onClose={onClose} severity={severity} sx={{ width: '100%', whiteSpace: 'pre-line' }} >
                {toastMessage}
                </Alert>
            </Snackbar>
        </>
    );
}